import { Order } from '@/app/shared/interface/order.interface';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-return-order-modal',
  templateUrl: './return-order-modal.component.html',
  styleUrl: './return-order-modal.component.scss'
})
export class ReturnOrderModalComponent {
  public order: Order | undefined;

  @ViewChild('returnOrderModal', { static: false }) thisModal: TemplateRef<string>;

  constructor(
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platformId: Object,

  ) {

  }

  openModal(order: Order) {
    if (isPlatformBrowser(this.platformId)) {
      this.order = order;
      this.modalService.open(this.thisModal, {
        ariaLabelledBy: 'return-order-Modal',
        centered: true,
        windowClass: 'theme-modal  modal-xl',
      });
    }
  }

  createSuccess(event: any) {
    this.modalService.dismissAll();
  }

  ngOnDestroy() {
    this.modalService.dismissAll();
  }
}
